module.exports = __webpack_public_path__ + "img/featureImg2.6c54c08b.png";